import React from 'react'
import { getFormValue } from 'tyan/public/utility'

class ChangeInstrumentNumberDiv extends React.Component {
    state = {
        id: this.props.id || 0,
    }

    componentDidMount = () => {
        this.doGetChangeInstrumentNumber()
    }

    doGetChangeInstrumentNumber = () => {
        const { id } = this.state
        Tyan.doPostEvent('GetChangeInstrumentNumber', {
            data: { id },
            onEnd: ({ errorMessage, optionsParas, initValues基本信息 }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                } else {
                    this.setState({ optionsParas, initValues基本信息, changedValues基本信息: {} })
                }
            }
        })
    }

    handlerSave = () => {
        const { onClose, onRefresh } = this.props
        Tyan.doPostEvent('SaveChangeInstrumentNumber', {
            data: Tyan.utility.getChangedFieldsets(this, '基本信息', false),
            onEnd: ({ errorMessage, id }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                } else {
                    Ext.toast('保存成功')
                    onClose && onClose()
                    onRefresh && onRefresh()
                }
            }
        })
    }

    handlerClose = () => {
        const { onClose } = this.props
        if (!this.bChanged()) {
            onClose && onClose()
            return
        }
        Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
    }

    bChanged = () => {
        return Tyan.utility.hasChangedValues(this)
    }

    fieldset基本信息 = () => {
        return [
            { _text: '设备编号', required: true, },
        ]
    }

    render() {
        const { showMessage: Message, showBody: Body } = this.props
        const { id, readOnly, initValues基本信息 } = this.state
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />

        const bChanged = this.bChanged()
        return <Body data={this} maxWidth={600}
            controls={
                readOnly ? [{ _button: '关闭', handler: this.handlerClose }] :
                    [
                        { _button: '保存', handler: this.handlerSave, disabled: !bChanged || !getFormValue(this, '基本信息', '设备编号'), },
                        { _button: bChanged && '取消' || '关闭', handler: this.handlerClose },
                    ]
            }
            fieldsets={
                [
                    { title: '', name: '基本信息', _fieldset: this.fieldset基本信息(), },
                ]}
        />
    }
}

export default ChangeInstrumentNumberDiv